"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _List = require("react-mdl/lib/List");

var _QuizHomeStyle = require("./styles/QuizHomeStyle");

var _GameService = _interopRequireDefault(require("./services/GameService"));

var _UserService = _interopRequireWildcard(require("./services/UserService"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _QuizHome = _interopRequireDefault(require("./QuizHome.scss"));

var _RunningGames = _interopRequireDefault(require("./RunningGames.scss"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _QuizStrings = require("./QuizStrings");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _QuizTournament = require("./QuizTournament");

var _Constants = require("../../constants/Constants");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _RestService = _interopRequireDefault(require("./services/RestService"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var RunningGames = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(RunningGames, _DataStoreComponent);

  var _super = _createSuper(RunningGames);

  function RunningGames(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, RunningGames);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      console.log('running games did mount', _this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME]);
      setTimeout(function () {
        var innerDivHeight = document.querySelector('#innerContent');

        if (innerDivHeight && _this.state.scrollHeight < innerDivHeight.scrollHeight - 10) {
          // eslint-disable-line no-magic-numbers
          _this.setState({
            scrollArrow: true
          });
        }
      }, 2000); // eslint-disable-line no-magic-numbers

      if (_this.props.hidden === false) {
        console.log('running games on show or mount componentDidMount');

        _this.onShowOrMount();
      } // console.log('running games component did mount', this.props.isTournament, this.state.data, this.props.isTournament && (this.state.data[DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === TOURNAMENT_PHASES.PLAY_GAMES || this.state.data[DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === TOURNAMENT_PHASES.WAIT_FOR_END))


      if (_this.props.isTournament && (_this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES || _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === _QuizTournament.TOURNAMENT_PHASES.WAIT_FOR_END)) {
        // console.log('running games component before set interval', this.waitingInterval, TOURNAMENT_WARNING_TIMEOUT)
        _this.waitingInterval = setInterval(function () {
          // console.log('running games component set interval')
          _this.checkForRunningGames();
        }, _Constants.TOURNAMENT_WARNING_TIMEOUT);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserDataById", function (userId) {
      console.log('getUserDataById', userId);
      var opponents = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS];
      var opponentData = opponents.find(function (opponent) {
        return opponent.id === userId;
      });

      if (opponentData) {
        return opponentData;
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeGame", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(game, opponent) {
        var _UserService$getPlaye, userData, selectedOpponentData, nextRoundAvailable;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('running games changeGame', game, _this.id); // set game application state

                _context.next = 3;
                return _EquizzerActions["default"].updateGame(game);

              case 3:
                // get the player state (challenger or opponent)
                _UserService$getPlaye = _UserService["default"].getPlayerState(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], opponent, game), userData = _UserService$getPlaye.userData, selectedOpponentData = _UserService$getPlaye.selectedOpponentData; // update logged in player's game state

                _context.next = 6;
                return _EquizzerActions["default"].setUser(userData, 'changeGame');

              case 6:
                _context.next = 8;
                return _EquizzerActions["default"].setUserPoints(userData.points);

              case 8:
                _context.next = 10;
                return _EquizzerActions["default"].setOpponent(selectedOpponentData);

              case 10:
                nextRoundAvailable = _this.nextRoundAvailable(game);
                console.log('nextRoundAvailable', nextRoundAvailable);

                if (nextRoundAvailable === 1) {
                  _this.props.onChooseCategory(game, true);
                } else if (nextRoundAvailable === 2) {
                  _this.props.onNextRound(game, opponent);
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkForRunningGames", function () {
      var runningGames = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME];
      var unfinishedUserGames = runningGames.filter(function (game) {
        return !game.finished && game.hasOwnProperty('tournament') && (game.challenger === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id || game.opponent === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id);
      });

      if ((!unfinishedUserGames || unfinishedUserGames.length === 0) && _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT].phase === _QuizTournament.TOURNAMENT_PHASES.WAIT_FOR_END) {
        clearInterval(_this.waitingInterval);

        if (_this.waitingDialog) {
          _this.waitingDialog();
        }

        _this.waitingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('TOURNAMENT_FINISHED_TEXT'), (0, _QuizStrings.getString)('TOURNAMENT_FINISHED_TITLE'), false);
        return;
      }

      var groupUsers = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS];
      var tournamentData = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT];
      var maxConcurrentGames = tournamentData.concurrentGamesPerUser || 3;
      var teams = (0, _values["default"])(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT]['teams']);
      var team1 = teams[0];
      var team2 = teams[1];
      var team1User = team1.members.find(function (user) {
        return user.id === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id;
      });
      var teamToCheck = team1User ? team2 : team1;
      var playableUser = null;
      teamToCheck.members.forEach(function (userObj) {
        var user = groupUsers.find(function (user) {
          return user.id === userObj.id;
        });

        if (!user || user.id === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
          return;
        }

        var userGame = user.game ? runningGames.find(function (game) {
          return game.id === user.game && game.hasOwnProperty('tournament');
        }) : null;
        var playableUserGame = playableUser && playableUser.game ? runningGames.find(function (game) {
          return game.id === playableUser.game && game.hasOwnProperty('tournament');
        }) : null;

        if (userGame && playableUserGame) {
          var currentPlayableUserLastUpdated = new Date(playableUserGame.lastUpdated).getTime();
          var userLastUpdated = new Date(userGame.lastUpdated).getTime();

          if (maxConcurrentGames && maxConcurrentGames > user.openGamesCount) {
            if (userLastUpdated < currentPlayableUserLastUpdated) {
              if (!userGame.finished && userGame.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                // console.log(`setting user ${user.nickname} as playable user because game is older as the game against ${playableUser.nickname} and user has less than ${maxConcurrentGames} games`)
                playableUser = user;
              }
            }
          } else {
            if (userLastUpdated < currentPlayableUserLastUpdated) {
              if (!userGame.finished && userGame.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                // console.log(`setting user ${user.nickname} as playable user because game is older as the game against ${playableUser.nickname}`)
                playableUser = user;
              }
            }
          }
        } else if (userGame) {
          if (!userGame.finished && userGame.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
            // console.log(`setting user ${user.nickname} as playable user because game is open`)
            playableUser = user;
          }
        }
      });

      if (playableUser) {
        if (_this.playingDialog) {
          return;
        }

        var userGame = playableUser.game ? runningGames.find(function (game) {
          return game.id === playableUser.game && game.hasOwnProperty('tournament');
        }) : null;

        if (_this.waitingDialog) {
          _this.waitingDialog();
        }

        var okButton = {
          label: (0, _QuizStrings.getString)('JUMP_TO_THE_GAME'),
          callback: function callback() {
            _this.playingDialog = null;
            userGame ? _this.changeGame(userGame, playableUser) : _this.props.onSetOpponent(playableUser);
          }
        };
        var cancelButton = {
          label: (0, _QuizStrings.getString)('CANCEL'),
          callback: function callback() {
            _this.playingDialog = null;
          }
        };
        _this.playingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT', [playableUser.nickname]), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), false, [okButton, cancelButton], true);
      } else {
        var _playableUser = null;
        teamToCheck.members.forEach(function (userObj) {
          var user = groupUsers.find(function (user) {
            return user.id === userObj.id;
          });

          if (!user || user.id === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
            return;
          }

          var userGame = user.game ? runningGames.find(function (game) {
            return game.id === user.game;
          }) : null;

          if ((!userGame || userGame.finished) && tournamentData.phase === _QuizTournament.TOURNAMENT_PHASES.PLAY_GAMES) {
            if (maxConcurrentGames && maxConcurrentGames > user.openGamesCount) {
              console.log("setting user ".concat(user.nickname, " as playable user because he has no game with the current user and user has less than ").concat(maxConcurrentGames, " games"));
              _playableUser = user;
            } else {
              console.log("setting user ".concat(user.nickname, " as playable user because he has no game with the current user"), groupUsers);
              _playableUser = user;
            }
          }
        });

        if (_playableUser) {
          if (_this.playingDialog) {
            return;
          }

          if (_this.waitingDialog) {
            _this.waitingDialog();
          }

          var _okButton = {
            label: (0, _QuizStrings.getString)('JUMP_TO_THE_GAME'),
            callback: function callback() {
              _this.checkOpponent(_playableUser);
            }
          };
          var _cancelButton = {
            label: (0, _QuizStrings.getString)('CANCEL'),
            callback: function callback() {
              _this.playingDialog = null;
            }
          };
          _this.playingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT', [_playableUser.nickname]), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), false, [_okButton, _cancelButton], true);
        } else {
          if (_this.waitingDialog) {
            return;
          }

          var _cancelButton2 = {
            label: (0, _QuizStrings.getString)('OK'),
            callback: function callback() {
              _this.waitingDialog = null;
            }
          };
          _this.waitingDialog = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('WAIT_FOR_OPPONENT_TEXT'), (0, _QuizStrings.getString)('WAIT_FOR_OPPONENT_TITLE'), false, [_cancelButton2], true);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkOpponent", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(playableUser) {
        var userAuth, user, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage, _updatedUser, games, userGame;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.props.getAuthToken();

              case 2:
                userAuth = _context2.sent;
                user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER];
                playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
                _context2.next = 7;
                return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

              case 7:
                groupUsers = _context2.sent;

                if (!groupUsers) {
                  _context2.next = 17;
                  break;
                }

                storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
                _context2.next = 12;
                return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

              case 12:
                groupUsersWithImage = _context2.sent;
                _context2.next = 15;
                return _EquizzerActions["default"].setGroupUsers(groupUsersWithImage);

              case 15:
                _updatedUser = groupUsers.find(function (user) {
                  return user.id === playableUser.id;
                });
                console.log('checkOpponent', playableUser, _updatedUser);

              case 17:
                _context2.next = 19;
                return _GameService["default"].loadAllGame(userAuth);

              case 19:
                games = _context2.sent;
                _context2.next = 22;
                return _EquizzerActions["default"].setAllGame(games);

              case 22:
                userGame = updatedUser.game ? games.find(function (game) {
                  return game.id === updatedUser.game && game.hasOwnProperty('tournament');
                }) : null;

                if (!userGame || userGame.activePlayer === _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
                  _this.playingDialog = null;

                  _this.props.onSetOpponent(updatedUser);
                } else {
                  _this.playingDialog = null;
                  (0, _AlertHelper.showAlertWithOptions)({
                    html: (0, _ErrorHelper.getErrorMessage)('always running game present'),
                    title: (0, _QuizStrings.getString)('FAILURE'),
                    centeredContent: true,
                    showCloseButton: false
                  });
                }

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateTab", function () {
      console.log('running games update tab');

      if (!_this.currentlyUpdating) {
        _this.updateGames(_this.props);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateGames", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var userAuth, user, games, allGame, playgrouIdToUse, groupUsers, storedImages, groupUsersWithImage, opponents;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.currentlyUpdating) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _this.currentlyUpdating = true;
              _context3.prev = 3;
              _context3.next = 6;
              return _this.props.getAuthToken();

            case 6:
              userAuth = _context3.sent;
              user = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER]; // this.props.showSpinner(true)

              _context3.next = 10;
              return _GameService["default"].loadAllGame(userAuth);

            case 10:
              games = _context3.sent;
              _context3.next = 13;
              return _GameService["default"].loadLastGameWithEachOpponent(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], games);

            case 13:
              allGame = _context3.sent;
              // let gotNoTournamentGames = true
              // let gotNoNormalGames = true
              //
              // allGame.forEach(game => {
              //   if (game.hasOwnProperty('tournament')) {
              //     gotNoTournamentGames = false
              //   }
              //   else {
              //     gotNoNormalGames = false
              //   }
              // })
              //
              // if (this.props.isTournament && gotNoTournamentGames || !this.props.isTournament && gotNoNormalGames) {
              //   this.props.showOpponentsTab()
              // }
              playgrouIdToUse = user.playgroupId ? user.playgroupId : _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
              _context3.next = 17;
              return _UserService["default"].getAllUsersAndLoadTheme(playgrouIdToUse, userAuth);

            case 17:
              groupUsers = _context3.sent;
              storedImages = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH];
              _context3.next = 21;
              return _UserService["default"].getUserImages(groupUsers, _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS], userAuth, storedImages);

            case 21:
              groupUsersWithImage = _context3.sent;

              // set groupUsers application state
              _EquizzerActions["default"].setGroupUsers(groupUsersWithImage); // filter logged in user from groupUsers list
              // and get list of opponents


              opponents = [];
              groupUsersWithImage.forEach(function (groupUser) {
                if (groupUser.id === user.id) {
                  user.picture = groupUser.picture; // set user application state

                  _EquizzerActions["default"].setUser(user, 'RunningGames 1');

                  _EquizzerActions["default"].setUserPoints(groupUser.points); // return

                } else {
                  opponents.push(groupUser);
                }
              });
              console.log('Success: polling, get all game', allGame);
              _context3.next = 28;
              return _EquizzerActions["default"].setAllGame(allGame);

            case 28:
              _EquizzerActions["default"].setOpponentsList(opponents);

              _this.currentlyUpdating = false; // this.props.showSpinner(false)

              _context3.next = 35;
              break;

            case 32:
              _context3.prev = 32;
              _context3.t0 = _context3["catch"](3);
              // this.props.showSpinner(false)
              console.log('ERROR: polling, get all game', _context3.t0);

            case 35:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 32]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function () {
      var scrollElement = document.querySelector('#scrollElement');

      if (scrollElement.scrollTop >= scrollElement.scrollHeight - scrollElement.offsetHeight && _this.state.scrollArrow) {
        _this.setState({
          scrollArrow: false
        });
      } else {
        if (!_this.state.scrollArrow) {
          _this.setState({
            scrollArrow: true
          });
        }
      }
    });
    _this.pollingGameData = {};
    _this.state = {
      scrollHeight: window.innerHeight - 225,
      // eslint-disable-line no-magic-numbers
      scrollArrow: false,
      currentTheme: ''
    };
    _this.showOrHideTimeout = null;
    _this.waitingInterval = null;
    _this.waitingDialog = null;
    _this.playingDialog = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(RunningGames.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER_IMAGE_PATH, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_OPPONENTS, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, _DataStore.DATA_STORE_PATHS.QD_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(RunningGames.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    _this.showOrHideTimeout = null;
    _this.id = _StringHelper["default"].createShortId();
    _this.currentlyUpdating = false;
    return _this;
  }

  (0, _createClass2["default"])(RunningGames, [{
    key: "nextRoundAvailable",
    value: function nextRoundAvailable(game) {
      var latestRoundNumber = game.rounds.length - 1; // return -1 if game is dirty -> game on client is newer than on the server, wait for post to go through
      // return 0 if no next round
      // return 1 if next round && choose Category
      // return 2 if next round && no choose Category

      if (game.isDirty) {
        return -1;
      }

      if (game.challenger === this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && game.rounds[latestRoundNumber].actionState === 'challengerMustAnswer' && !game.finished || game.opponent === this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id && game.rounds[latestRoundNumber].actionState === 'opponentMustAnswer' && !game.finished) {
        return 2;
      } else if (game.rounds[latestRoundNumber].actionState === 'chooseCategory' && game.activePlayer === this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id) {
        return 1;
      }

      return 0;
    }
  }, {
    key: "componentWillReceiveProps",

    /*
    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState)
    }
    */
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.hidden === true && this.props.hidden === false) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          _this2.onHideOrUnmount();
        }, 500);
      } else if (nextProps.hidden === false && this.props.hidden === true) {
        clearTimeout(this.showOrHideTimeout);
        this.showOrHideTimeout = setTimeout(function () {
          console.log('running games on show or mount willReceiveProps');

          _this2.onShowOrMount();
        }, 500);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.showOrHideTimeout);
      this.onHideOrUnmount();
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(RunningGames.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "onHideOrUnmount",
    value: function onHideOrUnmount() {
      console.log('running games om hide or unmount');
      document.removeEventListener('initQuiz', this.updateGames);
      clearInterval(this.pollingGameData);
      clearInterval(this.waitingInterval);

      _DeviceInfoHelper["default"].removeOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].removeOfflineListener(this.innerForceUpdate);

      console.log('running games all timers cleared', this.pollingGameData, this.waitingInterval);
    }
  }, {
    key: "onShowOrMount",
    value: function onShowOrMount() {
      var _this3 = this;

      document.removeEventListener('initQuiz', this.updateGames);
      document.addEventListener('initQuiz', this.updateGames);

      if (!_config["default"].disableQuizPolling) {
        console.log('running games onShowOrMount', this.id, this.pollingGameData);
        clearInterval(this.pollingGameData);
        this.pollingGameData = setInterval(function () {
          if (_this3.currentlyUpdating) {
            console.log('running games wird grade aktualisiert');
          } else {
            console.log('running games interval call', _this3.id);

            _this3.updateGames();
          }
        }, 30000); // eslint-disable-line no-magic-numbers
      }

      this.updateGames();

      _NavigationManager["default"].setCurrentLocation('running_games');

      _DeviceInfoHelper["default"].addOnlineListener(this.innerForceUpdate);

      _DeviceInfoHelper["default"].addOfflineListener(this.innerForceUpdate);
    }
  }, {
    key: "renderPresence",
    value: function renderPresence(opponent) {
      if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES]) {
        var presences = this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES];
        var isPresent = opponent.isRobot || presences && Boolean(presences[opponent.nickname]);
        var isInvisible = !opponent.isRobot && isPresent && !this.state.data[_DataStore.DATA_STORE_PATHS.QD_PRESENCES][opponent.nickname].showOnlineState;
        var cssClass;
        var content = '';

        if (window.ablyConnectivity.state !== 'connected') {
          cssClass = _QuizHome["default"].deviceOffline;
        } // else if (isInvisible) {
        //   cssClass = styles.userInvisible
        //   content = '?'
        // }
        else if (isPresent && !isInvisible) {
            cssClass = _QuizHome["default"].userOnline;
          } else {
            cssClass = _QuizHome["default"].userOffline;
          }

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: cssClass
        }, content);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props;

      if (!props.hidden && (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME] || this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME].length === 0)) {
        // eslint-disable-line no-magic-numbers
        return /*#__PURE__*/_react["default"].createElement("p", null, "Keine Spiele vorhanden");
      }

      var latestGames = _GameService["default"].getFilteredGames(this.state.data[_DataStore.DATA_STORE_PATHS.QD_ALL_GAME], this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER]);

      var opponentDetails = _UserService["default"].mapOpponentsInfoToId(this.state.data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS]);

      var dynamicStyles = (0, _QuizHomeStyle.getStyles)(this.state, this.props);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        className: _QuizHome["default"].innerContent,
        style: dynamicStyles.outerStyle
      }, latestGames.sort(function (obj1, obj2) {
        if (obj1.game_status > obj2.game_status) return 1; // eslint-disable-line no-magic-numbers

        if (obj1.game_status < obj2.game_status) return -1; // eslint-disable-line no-magic-numbers

        if (obj1.game_status === obj2.game_status) {
          var game1Data = obj1;
          var game2Data = obj2;
          var opponent1Id = game1Data.opponent;
          var opponent2Id = game2Data.opponent;

          if (_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === opponent1Id) {
            opponent1Id = game1Data.challenger;
          }

          if (_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === opponent2Id) {
            opponent2Id = game2Data.challenger;
          }

          if (_config["default"].sortPlayersByLastName) {
            if (opponentDetails[opponent1Id] && opponentDetails[opponent2Id]) {
              var obj1LastNameArray = opponentDetails[opponent1Id].nickname.split(' ');
              var obj1LastName = obj1LastNameArray.length > 1 ? obj1LastNameArray[1] : opponentDetails[opponent1Id].nickname;
              var obj2LastNameArray = opponentDetails[opponent2Id].nickname.split(' ');
              var obj2LastName = obj2LastNameArray.length > 1 ? obj2LastNameArray[1] : opponentDetails[opponent2Id].nickname;
              if (obj1LastName.toLowerCase() > obj2LastName.toLowerCase()) return 1;
              if (obj1LastName.toLowerCase() < obj2LastName.toLowerCase()) return -1;
              return 0;
            } else {
              return 0;
            }
          } else {
            if (obj1.lastUpdated < obj2.lastUpdated) return 1; // eslint-disable-line no-magic-numbers

            if (obj1.lastUpdated > obj2.lastUpdated) return -1; // eslint-disable-line no-magic-numbers

            return 0; // eslint-disable-line no-magic-numbers
          }
        }

        return 0; // eslint-disable-line no-magic-numbers
      }).map(function (gameObj) {
        var gameData = gameObj;
        var opponentId = gameData.opponent;

        if (_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id === opponentId) {
          opponentId = gameData.challenger;
        }

        if (opponentDetails.length === 0) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "Keine Gegner vorhanden");
        }

        if (!opponentDetails[opponentId]) {
          return null;
        }

        var nicknameToUse = opponentDetails[opponentId].nickname;

        if (_config["default"].sortPlayersByLastName) {
          var nicknameArray = opponentDetails[opponentId].nickname.split(' ');
          nicknameToUse = nicknameArray.length > 1 ? "".concat(nicknameArray[1], ", ").concat(nicknameArray[0]) : opponentDetails[opponentId].nickname;
        }

        var sendMessage = _DeviceInfoHelper["default"].isBrowser() ? /*#__PURE__*/_react["default"].createElement("div", null) : /*#__PURE__*/_react["default"].createElement("div", {
          onClick: function onClick() {
            return props.onSentPushToOpponent(opponentDetails[opponentId]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _QuizHome["default"].messageIcon,
          name: "envelope-o"
        }));
        return gameData.finished ? /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "".concat(gameObj.opponent, "_").concat(gameObj.challenger),
          className: _QuizHome["default"].listItem,
          style: dynamicStyles.listItemStyle
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: _QuizHome["default"].opponentsText,
          onClick: function onClick() {
            return props.onShowResults(gameData, opponentDetails[opponentId]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _QuizHome["default"].icon,
          name: "check-circle"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].thumb
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "img",
          src: opponentDetails[opponentId].picture ? opponentDetails[opponentId].picture : _UserService.DEFAULT_IMAGE
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanText
        }, _this4.renderPresence(opponentDetails[opponentId]), " ", nicknameToUse)), sendMessage) : // ELSE: check who is active player
        opponentId === gameData.activePlayer || gameData.isDirty ? /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "".concat(gameObj.opponent, "_").concat(gameObj.challenger),
          className: _QuizHome["default"].listItem,
          style: dynamicStyles.listItemStyle
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: _QuizHome["default"].opponentsText,
          onClick: function onClick() {
            return props.onShowResults(gameData, opponentDetails[opponentId]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _QuizHome["default"].icon,
          name: "hourglass-half"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].thumb
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "img",
          src: opponentDetails[opponentId].picture ? opponentDetails[opponentId].picture : _UserService.DEFAULT_IMAGE
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanText
        }, _this4.renderPresence(opponentDetails[opponentId]), " ", nicknameToUse)), sendMessage) : /*#__PURE__*/_react["default"].createElement(_List.ListItem, {
          key: "".concat(gameObj.opponent, "_").concat(gameObj.challenger),
          className: _QuizHome["default"].listItem,
          style: dynamicStyles.listItemStyle
        }, /*#__PURE__*/_react["default"].createElement(_List.ListItemContent, {
          className: _QuizHome["default"].opponentsText,
          onClick: function onClick() {
            return props.onShowResults(gameData, opponentDetails[opponentId]);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
          className: _QuizHome["default"].icon,
          name: "play-circle"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].thumb
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "img",
          src: opponentDetails[opponentId].picture ? opponentDetails[opponentId].picture : _UserService.DEFAULT_IMAGE
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizHome["default"].spanText
        }, _this4.renderPresence(opponentDetails[opponentId]), " ", nicknameToUse)), sendMessage);
      }));
    }
  }]);
  return RunningGames;
}(_DataStoreComponent2["default"]);

exports["default"] = RunningGames;
RunningGames.propTypes = {
  opponents: _propTypes["default"].object.isRequired,
  user: _propTypes["default"].object.isRequired,
  onShowResults: _propTypes["default"].func.isRequired,
  onSentPushToOpponent: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  getAuthToken: _propTypes["default"].func.isRequired,
  hidden: _propTypes["default"].bool,
  showOpponentsTab: _propTypes["default"].func,
  isTournament: _propTypes["default"].bool,
  onChooseCategory: _propTypes["default"].func,
  onNextRound: _propTypes["default"].func,
  onSetOpponent: _propTypes["default"].func
};